import { Typography } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import React from 'react';
import SectionChapter from '../../Tutorial/SectionChapter';
import SectionHeader from '../../Tutorial/SectionHeader';
import { FindMoreButton } from '../../Home/HomeFeatures/FindMoreButton';
import { tutorialLinks } from '../../../common/urlLinks';

const MathConvertor = ({ refs }) => {
    const paste = [
        {
            children: (
                <>
                    <ul>
                        <li>
                            <Typography variant="h6">
                                <FormattedMessage id="redesign.page.home.feature.mathConvertor.description1" />
                            </Typography>
                        </li>
                        <li>
                            <Typography variant="h6">
                                <FormattedMessage id="redesign.page.home.feature.mathConvertor.description2" />
                            </Typography>
                        </li>
                        <li>
                            <Typography variant="h6">
                                <FormattedMessage id="redesign.page.home.feature.mathConvertor.description3" />
                            </Typography>
                        </li>
                    </ul>
                    <a href={tutorialLinks.mathConvertor}>
                        <FindMoreButton />
                    </a>
                </>
            ),
        },
    ];
    return (
        <>
            <SectionHeader
                refs={refs}
                title={'redesign.page.home.feature.mathConvertor.tag'}
                id={'section-mathConvertor'}
                img={`/static/asset/img/features/formule_matematice.png`}
            />
            <SectionChapter
                refs={refs}
                id={'section-mathConvertor-section'}
                title={'redesign.page.home.feature.mathConvertor.description'}
                explanations={paste}
            />
        </>
    );
};

export default MathConvertor;
